import { useQuery } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';

/**
 * GET /api/eraf/permissions — Permission 카탈로그 조회 (read-only)
 * queryKey: ['role-management', 'permissions']
 */
export function usePermissionCatalog(params?: { resource?: string; action?: string }) {
  return useQuery({
    queryKey: ['role-management', 'permissions', params],
    queryFn: () => roleApi.permissionCatalog(params),
    staleTime: 5 * 60_000, // 5분 — 카탈로그는 자주 변경되지 않음
  });
}
